import PropTypes from 'prop-types';

import { getAffirmativeOptions } from '../../../utils/data';
import { getModuleLineNumbersFromProject } from '../../../utils/utilities';

import Joi from 'joi';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import withProjectDetails from '../../hoc/withProjectDetails';

class CustomUTMStructureSummaryOverviewForm extends Form {
	state: any = {
		data: { hasAnomalies: '', itemName: '', overview: '' },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
		itemName: Joi.object({
					label: Joi.string().required(),
					value: Joi.string().required(),
					__isNew__: Joi.boolean().optional(),
				})
					.required()
					.label('Item Name'),
        overview: Joi.string().min(10).required().label('Overview'),
	};

    static propTypes = {
		initialSummary: PropTypes.object,
        onSave: PropTypes.func
    }

	componentDidMount(): void {
		if (this.props.initialSummary) {
			this.setState({ 
				data: {
					...this.props.initialSummary,
					itemName: this.createNewMultiSelectOption(this.props.initialSummary.itemName),
				}
			 });
		}
	}

	createNewMultiSelectOption = (value: string) => {
		return { label: value, value };
	}

	doSubmit = (): void => {
		this.props.onSave(this.getApiData());
		toastService.success('Saved successfully!');
	};

	getApiData = () => {
		return { 
			hasAnomalies: this.state.data.hasAnomalies,
			itemName: this.state.data.itemName.value,
			overview: this.state.data.overview,
		};
	}

	getItemNameOptions = () => {
		if (this.props.projectDetails) {
			return getModuleLineNumbersFromProject(this.props.projectDetails).map(this.createNewMultiSelectOption);
		}
		
		return [];
	};

	handleNewOptionCreation = (newLineNumber: string) => {
		const newItemName = this.createNewMultiSelectOption(newLineNumber);
		const data = { ...this.state.data, itemName: newItemName };

		this.setState({ data });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="container">
                    <div className="row">
						<div className="col">
							{this.renderCreatableMultiselect({
								closeMenuOnSelect: true,
								options: this.getItemNameOptions(),
								name: 'itemName',
								placeholder: 'Enter Item Name',
								label: 'Item Name',
								isMulti: false,
								onCreateOption: this.handleNewOptionCreation
							})}
						</div>


                        <div className="col-6">
							{this.renderSelect({
								options: getAffirmativeOptions(),
								name: 'hasAnomalies',
								label: 'Has Anomalies',
								placeholder: 'Select Has Anomalies',
							})}
                        </div>
                    </div>
					
					<div className="my-4 divider"></div>

					{this.renderTextEditor({
						name: 'overview',
						label: 'Overview',
						placeholder: 'Enter Overview',
					})}
					
					<div className="d-flex justify-content-end">
						{this.renderButton('Save')}
					</div>
                </div>
			</form>
		);
	}
}

export default withProjectDetails(CustomUTMStructureSummaryOverviewForm);
